import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import { Analytics, logEvent, setUserId, setUserProperties } from '@angular/fire/analytics';
import { SessionService } from './services/session_service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  isDisplayDashboard: boolean = true;
  path: any;
  favIcon: any = document.querySelector('#appIcon');
  title: any;

  constructor(private router: Router,private titleservice: Title,
              private analytics: Analytics, private sessionService: SessionService
  ) {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        // Angular routing never reloads the page, so GA4's page_location would
        // otherwise stay frozen on the first URL for the whole session. Firing
        // page_view here is what lets BigQuery attribute engagement_time_msec
        // to the actual current route instead of only the initial one.
        logEvent(this.analytics, 'page_view', {
          page_location: window.location.origin + val.urlAfterRedirects,
          page_path: val.urlAfterRedirects,
          page_title: this.titleservice.getTitle(),
        });
        if (window.location.pathname == '/login' || window.location.pathname == '/') {
          this.isDisplayDashboard = false;
          this.path = "login";
        } 
        else if (window.location.pathname == '/registerotp') {
          this.isDisplayDashboard = false;
          this.path = "registerotp";
        }
        else if (window.location.pathname.indexOf('/forgotpassword') > -1) {
          this.isDisplayDashboard = false;
          this.path = "forgotpassword";
        } else if (window.location.pathname.indexOf('/forgotpassword') > -1) {
          this.isDisplayDashboard = false;
          this.path = "forgotpassword";
        } else if (window.location.pathname.indexOf('/resetpwd') > -1) {
          this.isDisplayDashboard = false;
          this.path = "resetpwd";
        }
        else {
          this.isDisplayDashboard = true;
          //console.log('Route change detected');
        }
      }
    });
  }
  ngOnInit() {
    let token=localStorage.getItem('TOKEN');
    setUserProperties(this.analytics, {
              env: environment.appEnv
            });
    if (token) {
      const lawyer_id = localStorage.getItem('user_id');
      if (lawyer_id)
      {
        setUserId(this.analytics, lawyer_id);
        // this.sessionService.init();
      }
        
    }


    if(!token && window.location.pathname.indexOf("/grid") !=0){
      //console.log("window.location.pathname")
      this.router.navigate(['/login']);
    }
    if (window.location.pathname == '/login' || window.location.pathname == '/') {
      this.isDisplayDashboard = false;
      this.path = "login";
    } 
    else if (window.location.pathname == '/registerotp') {
          this.isDisplayDashboard = false;
          this.path = "registerotp";
    }
    else if (window.location.pathname.indexOf('/forgotpassword') > -1) {
      this.isDisplayDashboard = false;
      this.path = "forgotpassword";
    } else if (window.location.pathname.indexOf('/resetpwd') > -1) {
      this.isDisplayDashboard = false;
      this.path = "resetpwd";
    }
    else {
      this.isDisplayDashboard = true;
    }
    if (environment.product=="connect"){
      this.titleservice.setTitle("CofferConnect")
      this.favIcon.href = "/assets/site/images/cofferconnect-logo.png";
      // add the image to assests/img folder and change the patch here
    } else if(environment.product=="content"){
      this.titleservice.setTitle("ContentCoffer")
      this.favIcon.href = "/assets/site/images/contentcoffer-logo.png";
       // add the image to assests/img folder and change the patch here
    }
    else if(environment.product=="corporate"){
      this.titleservice.setTitle("Lex-Z CORPORATE")
      this.favIcon.href = "assets/img/logo.svg";
       // add the image to assests/img folder and change the patch here
    }
  }

}
